import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import GetTopPlayerListRequest from '@/api/top-list/get-top-player-list.request';
import GetTopWinListRequest from '@/api/top-list/get-top-win-list.request';
import { Ref } from 'vue';

export class TopListApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
  ) {}

  public get getTopPlayerListRequest(): GetTopPlayerListRequest {
    return new GetTopPlayerListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.GET,
    );
  }

  public get getTopWinListRequest(): GetTopWinListRequest {
    return new GetTopWinListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.GET,
    );
  }
}
